import PropTypes from 'prop-types';

import {monetaryConstants} from '../Monetary';
import {trendConstants} from '../Trend';


// ------ navigation
export const NAV_CONTENT_DETAIL_PAGE = '/buy/content/:contentId';


// ------ departments
export const CONTENT_DEPARTMENT_ALL = 'all';


// ------ types
export const CONTENT_TYPE_ARTICLE = 'article';

export const CONTENT_TYPES = [
    CONTENT_TYPE_ARTICLE
];


// ------ status
export const CONTENT_STATUS_ARCHIVE = 'archive';
export const CONTENT_STATUS_DISABLED = 'disabled';
export const CONTENT_STATUS_IMPORT = 'import';
export const CONTENT_STATUS_NOT_ORDERABLE = 'not-orderable';
export const CONTENT_STATUS_ONLINE = 'online';

export const CONTENT_STATUSES = [
    CONTENT_STATUS_ARCHIVE,
    CONTENT_STATUS_DISABLED,
    CONTENT_STATUS_IMPORT,
    CONTENT_STATUS_NOT_ORDERABLE,
    CONTENT_STATUS_ONLINE
];


// ------ shapes
export const SHAPE_CONTENT_AUTHOR = {
    function: PropTypes.string,
    name: PropTypes.string.isRequired
};

export const SHAPE_CONTENT_AUTHORS = {
    authors: PropTypes.arrayOf(PropTypes.shape(SHAPE_CONTENT_AUTHOR)).isRequired
};


export const SHAPE_CONTENT_DISTRIBUTION_SCOPE = {
    countryAlpha2: PropTypes.arrayOf(
        PropTypes.string
    ).isRequired
};


export const SHAPE_CONTENT_DISTRIBUTION = {
    exclude: PropTypes.shape(SHAPE_CONTENT_DISTRIBUTION_SCOPE),
    include: PropTypes.shape(SHAPE_CONTENT_DISTRIBUTION_SCOPE)
};


export const SHAPE_CONTENT_PUBLICATION = {
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    name: PropTypes.string.isRequired
};


export const SHAPE_CONTENT_SIZE = {
    wordCount: PropTypes.number.isRequired
};


export const SHAPE_CONTENT_STATS = {
    salesCount: PropTypes.number.isRequired
};


export const SHAPE_CONTENT_STATUES = PropTypes.oneOf(CONTENT_STATUSES);


export const SHAPE_CONTENT_TREND_BASE = {
    direction: PropTypes.number.isRequired,
    isTrending: PropTypes.bool.isRequired
};

export const SHAPE_CONTENT_TREND_MATCH_QUOTA = {
    ...SHAPE_CONTENT_TREND_BASE,
    keywordMatchQuotas: PropTypes.arrayOf(
        PropTypes.shape(trendConstants.SHAPE_KEYWORD_MATCH_QUOTA)
    ).isRequired,
    overallQuota: PropTypes.number.isRequired
};


export const SHAPE_CONTENT_TILE = {
    department: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    publicId: PropTypes.string.isRequired,
    publication: PropTypes.shape(SHAPE_CONTENT_PUBLICATION).isRequired,
    price: PropTypes.shape(monetaryConstants.SHAPE_PRICE).isRequired,
    size: PropTypes.shape(SHAPE_CONTENT_SIZE).isRequired,
    stats: PropTypes.shape(SHAPE_CONTENT_STATS).isRequired,
    title: PropTypes.string.isRequired,
    trend: PropTypes.oneOfType([
        PropTypes.shape(SHAPE_CONTENT_TREND_BASE),
        PropTypes.shape(SHAPE_CONTENT_TREND_MATCH_QUOTA)
    ]),
    type: PropTypes.oneOf(CONTENT_TYPES).isRequired
};


export const SHAPE_CONTENT_DETAILS = {
    ...SHAPE_CONTENT_TILE,
    ...SHAPE_CONTENT_AUTHORS,
    languageOriginal: PropTypes.string.isRequired
};
